define('modules/form/modal/create_link_modal_view',[
  'backbone',
  '_',
  'text!./create_link_modal_template.html',
], function (Backbone, _, modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
    },

    hasSidebar: false,
    pickers: [],
    subViews: [],
    tagName: 'div',
    className: 'create-link-modal',
    template: _.template(modal_template),

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-save-link': 'saveLink',
    },

    render: function () {
      this.$el.html(this.template({}));
      return this;
    },

    saveLink: function (e) {
      var display_text = this.$('#display_text').val();
      var webaddress = this.$('#webaddress').val();
      var link = '[url="' + webaddress + '"]' + display_text + '[/url]';
      e.preventDefault();

      Backbone.trigger('createLink', link);
      this.trigger('close');
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

